// actions/tutorial.ts — M1
import { defineAction } from '../define';
import { g } from '../guard';
declare module '../registry' {
  interface ActionMap { 'tutorial.advance': { req: { step: number }; res: { step: number } } }
}
export const tutorialAdvance = defineAction('tutorial.advance', g.obj({ step: g.int(0, 99) }));
